import React, { useState, useEffect, useRef } from "react";
import useComponentVisible from "../../../hooks/onclick-listner";
import downArrow from "../../../assets/SVGs/down-arow.svg";
import { DropDownInput, DropDownList, DropDownValue, DropDownListItems } from "./styles/dropdown";
import { defaultStyles } from "../../../constants/style-constants/utils";
import colors from "../../../constants/style-constants/colors";
export default function DropDown(props) {
  const {
    defaultValue,
    setSelectedItem,
    list,
    style,
    displayKey,
    name,
    placeholderName,
    value,
    disableSearch,
    listingStyle,
  } = (typeof props.value === "object" && props.value) || props;

  console.log("default value", defaultValue);
  const { ref, isComponentVisible, handleClose, setIsComponentVisible } = useComponentVisible(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [disable, setDisable] = useState(false);
  useEffect(() => {
    value && setSearchValue(value);
    console.log("list selected value", value);
    defaultValue && setSearchValue(defaultValue);
    console.log("defaultvalue", defaultValue);
    if (defaultValue) {
      console.log("defaultValue", defaultValue);
      setDisable(true);
    }
    if (props.readOnly) {
      console.log("defaultValue", defaultValue);
      setDisable(true);

      // setShowDropdown(false);
    }
  }, [list, defaultValue]);

  const filteredItems =
    (disableSearch && list) ||
    (list &&
      list.filter((item) => {
        return (
          item[displayKey] &&
          item[displayKey].toLowerCase().includes(searchValue && searchValue.toLowerCase())
        );
      }));

  console.log("filteredItems", filteredItems);
  const selectItem = (item) => {
    console.log("itemmm", item);
    console.log("setSelectedItem", setSelectedItem);
    setSelectedItem({ name: name, value: item[displayKey], item: item });
    handleClose();
    // setShowDropdown(false);
  };
  return (
    <div ref={ref}>
      <DropDownInput
        disabled={disable}
        style={{ ...style }}
        onClick={() => {
          setIsComponentVisible(!isComponentVisible);
          // setShowDropdown(!showDropdown);
        }}
      >
        <DropDownValue
          // style={{ ...style}}
          // disabled={disable}
          placeholder={placeholderName || "Select"}
          onChange={(e) => {
            setSearchValue(e.target.value);
          }}
          value={searchValue}
        ></DropDownValue>

        <img src={downArrow} height={15} width={15}></img>
      </DropDownInput>
      {isComponentVisible && !props.readOnly && (
        <DropDownList disabled={disable} style={listingStyle || style || { backgroundColor: colors.white }}>
          {list &&
            list.map((item, index) => (
              <DropDownListItems
                // readOnly={props.readOnly}
                key={index}
                onClick={() => {
                  setSearchValue(item[displayKey]);

                  selectItem(item);
                }}
              >
                {item[displayKey]}
              </DropDownListItems>
            ))}
        </DropDownList>
      )}
    </div>
  );
}
